import { render, staticRenderFns } from "./IP_ByReason.vue?vue&type=template&id=df9b556c&scoped=true&"
import script from "./IP_ByReason.vue?vue&type=script&lang=js&"
export * from "./IP_ByReason.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df9b556c",
  null
  
)

export default component.exports